import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IBrandInfo } from '../interfaces/brand/brand-info';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  public getBaseUrlByRegion(region: string) {
    return environment.settings.regions.find(item => item.region === region.toLowerCase())?.baseUrl;
  }

  public getBrandStyleScheme (brandInfo: IBrandInfo): any {
    return JSON.parse(brandInfo.brandStyleTheme)
  }

  public getLogoImageWidth (brandInfo: IBrandInfo) {
    let logoImageWidth = '100%';
    let configProperties = brandInfo.configProperties;
    // console.log('configProperties', configProperties);
    for (const propName in configProperties) {
      // console.log(propName, configProperties[propName]);
      if (propName == 'EAUTH_LOGO_IMG_WIDTH') {
        logoImageWidth = configProperties[propName];
        // console.log('ura!', logoImageWidth);
      }
    }
    return logoImageWidth;    
  }

  public getBrandConfigProperty(brandInfo: IBrandInfo, propName: string, defaultValue?: string): string {
    let propValue!: string;
    if (brandInfo) {
      const configProperties: Map<string, string> = new Map(Object.entries(brandInfo.configProperties));
      if (configProperties) {
        if (configProperties.has(propName)) {
          propValue = configProperties.get(propName) || '';
        }
      }
    }
    if (!propValue) {
      propValue = defaultValue || '';
    }
    return propValue;
  }

  public formatString(template: string, ...args: any[]): string {
    return template.replace(/{(\d+)}/g, (match, index) => {
        return typeof args[index] !== 'undefined' ? args[index] : match;
    });
  }

  // public getMessageOption(options: any, optionCode: string): string | undefined {
  //   let jsonObject = JSON.parse(options);
  //   if (!jsonObject) {
  //     return;
  //   }
  //   let map = new Map<string, string>();
  //   for (var value in jsonObject) {
  //     map.set(value, jsonObject[value]);
  //   }
  //   if (map.has(optionCode)) {
  //     return map.get(optionCode);
  //   }
  //   return;
  // }

  // Common error handling routines
  public handleError(error: HttpErrorResponse) {

    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error(error.message));  // 'Something bad happened; please try again later.'
    
  }

}
